<template>
  <div id="app">
    <div v-if="isAuthenticated" class="app-layout">
      <Sidebar />

      <div class="main-section">
        <PageHeader />
        <router-view class="page-content" />
      </div>
    </div>

    <router-view v-else />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Sidebar from '@/components/layout/Sidebar.vue'
import PageHeader from '@/components/layout/PageHeader.vue'

export default {
  components: {
    Sidebar,
    PageHeader
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapGetters('ui', ['isSidebarOpen'])
  },
  watch: {
    isSidebarOpen(isOpen) {
      // Lock body scroll when sidebar is open on mobile
      if (window.innerWidth <= 1024) {
        document.body.style.overflow = isOpen ? 'hidden' : ''
      }
    }
  },
  created() {
    this.initAuth()
  },
  methods: {
    ...mapActions('auth', ['initAuth'])
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden; /* 🔴 THIS STOPS PAGE SCROLL */
  font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

#app {
  height: 100vh;
}

/* Layout */
.app-layout {
  display: flex;
  height: 100vh;
}

/* Main Section */
.main-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f8fafc;
  overflow: hidden;
}

/* Page Content */
.page-content {
  flex: 1;
  overflow: auto; /* ✅ Only content scrolls if needed */
}
.global-container {
  width: 100%;
  background: #f8fafc;
  height: 100%;
}
.content {
  padding: 48px 40px;
}

/* Responsive styles */
@media (min-width: 1025px) {
  /* Desktop: main section has margin for sidebar */
  .main-section {
    margin-left: 280px;
  }
}

@media (max-width: 1024px) {
  /* Tablet and Mobile: no margin, full width */
  .main-section {
    margin-left: 0;
  }

  .content {
    padding: 32px 24px;
  }
}

@media (max-width: 768px) {
  .content {
    padding: 24px 16px;
  }
}

/* Vue-Toasted Styles */
.toasted-container .toasted {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 13px !important;
  font-weight: 500 !important;
  padding: 10px 14px !important;
  border-radius: 8px !important;
  min-height: auto !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
  max-width: 360px !important;
  line-height: 1.4 !important;
}

.toasted-container .toasted.toasted-primary {
  background: #1f2937 !important;
  color: white !important;
}

.toasted-container .toasted.success {
  background: #16a34a !important;
  color: white !important;
}

.toasted-container .toasted.error {
  background: #dc2626 !important;
  color: white !important;
}

.toasted-container .toasted .action {
  color: rgba(255, 255, 255, 0.7) !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  padding: 0 0 0 12px !important;
  margin: 0 !important;
  text-decoration: none !important;
  cursor: pointer;
  transition: color 0.15s ease;
}

.toasted-container .toasted .action:hover {
  color: white !important;
}
</style>
